<template>
  <div v-if="!empty" class="elevation-0 pa-4 ma-0" style="background:white; border-radius:3px;">
    <div v-if="failed" class="subheading error--text pb-2">Script reported failure</div>
    <div v-if="scriptName" class="subheading pb-1">Script: {{ scriptName }}</div>
    <div v-if="fullMessage" class="body-1 pb-2">{{ fullMessage }}</div>
    <div v-if="metadataText" class="body-1 pb-2">
      <div class="subheading">Metadata</div>
      <pre class="custom-event-pre">{{ metadataText }}</pre>
    </div>
    <div v-if="outputText" class="body-1 pb-2">
      <div class="subheading">Output</div>
      <pre class="custom-event-pre">{{ outputText }}</pre>
    </div>
    <div v-if="logsText" class="body-1">
      <div class="subheading">Logs</div>
      <pre class="custom-event-pre">{{ logsText }}</pre>
    </div>
  </div>
</template>

<script>
import { hasCustomEventDetail } from "@/components/timeline/customEventDetail"

export default {
  name: "CustomEvent",
  props: ["eventDateObj"],
  methods: {
    stringify(value) {
      if (value === undefined || value === null || value === "") {
        return ""
      }
      if (typeof value === "string") {
        return value
      }
      try {
        return JSON.stringify(value, null, 2)
      } catch (err) {
        return String(value)
      }
    }
  },
  computed: {
    params() {
      return this.eventDateObj && this.eventDateObj.params ? this.eventDateObj.params : {}
    },
    failed() {
      return this.eventDateObj && this.eventDateObj.success === false
    },
    scriptName() {
      return this.params.scriptName || ""
    },
    fullMessage() {
      return this.params.fullMessage || ""
    },
    metadataText() {
      return this.stringify(this.params.metadata)
    },
    outputText() {
      return this.stringify(this.params.output)
    },
    logsText() {
      if (this.params.logs !== undefined && this.params.logs !== null && this.params.logs !== "") {
        return this.stringify(this.params.logs)
      }
      return this.stringify(this.params.customLogs)
    },
    empty() {
      return !hasCustomEventDetail(this.eventDateObj)
    }
  }
}
</script>
<style>
.custom-event-pre {
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  font-size: 0.9em;
}
</style>
